import { Component, Mixins } from '@/vue-property-decorator'
import BaseCssVarProvide from '../../../../components/baseCssVarProvide'
import FavoriteIcon from '../../../components/favoriteIcon'
import GameNameVertical from '../gameNameVertical'

export class CssVarManager {
  // 不区分PC和H5形态,都使用相同的值
  // fallbackBackground = {
  //   '--fallback-background-font-size': '1.03rem',
  //   '--fallback-background-z-index': '0',
  //   '--fallback-background-border-radius': '0.14rem',
  //   '--fallback-background-image':
  //     'linear-gradient(to bottom, #bbf8ff, #7febff)',
  //   '--fallback-background-color': '#60d0ff'
  // }
  gameNameVertical = GameNameVertical.getCssVarSmall()
  /** 收藏图标位置 */
  favoriteIcon = FavoriteIcon.getCssVarRectangle()
  /** 收藏图标尺寸 */
  triangleHeart = FavoriteIcon.RectangleStar.getTriangleHeartSmall()
}
/** css变量控制器 此css仅能用于修改暴露的css样式,千万不要直接写一些额外的样式,不然容易出现异常 */
@Component<CssVarSmall>({
  name: 'CssVarSmall'
})
class CssVarSmall extends Mixins<BaseCssVarProvide<CssVarManager>>(
  BaseCssVarProvide
) {
  public static CssVarManager = CssVarManager
  /** 此布局下的基础样式值 */
  baseCssVarManager = () => new CssVarManager()
  // 渲染入口.
  render() {
    // 不需要通过css样式设置变量,则可以不用再包一层div了
    // return <div class={style['css-var-default']}>{this.$slots.default}</div>
    return this.$slots.default as unknown as VueTsxSupport.JSX.Element
  }
}
const _CssVarSmall = CssVarSmall
export default _CssVarSmall
